import styled, { css } from 'styled-components';

import { SPACING } from '~/common/layout-propertis/spacing';

export const OptionContainer = styled.div<{
  selected: boolean;
  highlighTitle: boolean;
  highlighIcon: boolean;
  width: string;
}>`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: ${SPACING._8};
  cursor: pointer;
  white-space: nowrap;
  transition: color 200ms;
  padding-right: ${SPACING._8};
  padding-left: ${SPACING._8};

  ${({ width }) =>
    width &&
    css`
      width: ${width};
    `}

  &:hover {
    color: ${({ theme }) => theme.neutral[50]};
  }
`;

export const OptionExtraContentWrapper = styled.div`
  height: 20px;
  width: 20px;
`;

export const IconWrapper = styled.i<{
  selected: boolean;
  highlighIcon: boolean;
}>`
  svg,
  div {
    transition: 200ms;
  }
`;

export const ArrowWrapper = styled.div`
  svg,
  div {
    transition: 200ms;
  }
`;

export const Title = styled.span<{ selected: boolean; highlighTitle: boolean }>`
  color: ${({ selected, highlighTitle, theme }) =>
    selected
      ? highlighTitle
        ? theme.green[500]
        : theme.neutral[50]
      : theme.neutral[400]};
  transition: color 200ms;
  user-select: none;

  ${({ selected, highlighTitle, theme }) =>
    !selected &&
    css`
      > span {
        transition: color 200ms;
        &:hover {
          color: ${highlighTitle ? theme.green[500] : theme.neutral[50]};
        }
      }
    `}
`;
